import { render } from "./Index.vue?vue&type=template&id=49d4cdc7&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=49d4cdc7&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d4cdc7"]])

export default __exports__